import PersonaScreen from "./PersonaScreen";

/** Director view — placeholder per ADR 0007. */
export default function DirectorScreen({ onLogout }: { onLogout: () => void }) {
  return (
    <PersonaScreen
      title="Legends · Director"
      copy="Direction console for the legend's operation."
      onLogout={onLogout}
    />
  );
}
